import { router } from "@inertiajs/react";
import { avisarDepressaDemais, eDepressaDemais } from "@/utils/depressaDemais";

/**
 * As visitas e os reloads parciais do Inertia (a agenda e a fila que recarregam com `only`, o mudar
 * de página…) que batem no limite de pedidos do servidor (429). A resposta não é do Inertia: ele
 * dispara o `invalid` e, sem isto, abria a resposta numa janela por cima da página ou não mostrava
 * nada. Aqui a janela não abre, a página fica como estava e aparece o aviso «Estás a ir depressa
 * demais…» (com o texto do servidor, quando é o limite do Construtor). Liga-se uma vez, no `app.tsx`.
 */
export function vigiarVisitasDepressaDemais(): () => void {
    return router.on("invalid", (evento) => {
        const resposta = evento.detail.response;
        if (resposta?.status !== 429) {
            return;
        }
        evento.preventDefault();
        avisarDepressaDemais(eDepressaDemais(resposta.status, resposta.data) ? resposta.data.texto : null);
    });
}
